import { useApi } from './use-api'
import useUnauthRedirect from './use-unauth-redirect'

export const usePointsBalance = () => {
  const { api } = useApi()
  const { isAuthenticated, sessionLoading } = useUnauthRedirect(false)
  const { data: points } = api.auth.getMemberPoints.useQuery(undefined, {
    enabled: isAuthenticated && !sessionLoading,
  })
  return points
}
